import { z } from "zod"
import { useForm, zodResolver } from "@mantine/form"
import { TextInput, Button, Group, LoadingOverlay } from "@mantine/core"
import { Icon } from "@material-tailwind/react"
import useFetchAndLoad from "hooks/useFetchAndLoad.ts"
import { update } from "services/api.service"

const schema = z.object({
  name: z.string().min(1, { message: "Nombre debe tener al menos 1 letra" }),
  lastName: z.string().min(1, { message: "Primer apellido debe tener al menos 1 letra" }),
})

const SupplierPersonForm = ({ data, refresh, isCreation, notifications, endpoint, supplier }) => {
  const { loading, callEndpoint } = useFetchAndLoad()

  const form = useForm({
    schema: zodResolver(schema),
    initialValues: {
      name: data.first_name,
      lastName: data.last_name,
    },
  })

  const handleSubmit = async (values) => {
    const { name, lastName } = values
    const person = {
      ...data,
      first_name: name,
      last_name: lastName,
      active: data.active ? true : supplier.persons.length > 0 ? false : true,
    }

    let notificacionTitle = data._id ? "Persona actualizada" : "Persona creada"
    let notificationDescription = data._id
      ? "La persona ha sido actualizada con éxito."
      : "La persona ha sido creada con éxito."

    if (data._id) {
      const index = supplier.persons.findIndex((person) => person._id === data._id)
      supplier.persons[index] = person
    } else {
      supplier.persons = [...supplier.persons, person]
    }

    await callEndpoint(update(endpoint, supplier))
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          refresh()
          notifications.showNotification({
            color: "green",
            title: notificacionTitle,
            message: notificationDescription,
            icon: <Icon name={"check"} />,
          })
        }
      })
      .catch((error) => {
        showErrorNotification()
      })
  }

  const showErrorNotification = () => {
    notifications.showNotification({
      color: "red",
      title: "Error, por favor intentelo nuevamente.",
      message: "Si el problema persiste contactar a soporte.",
      icon: <Icon name={"close"} />,
    })
  }

  return (
    <>
      {loading && <LoadingOverlay visible={true} />}
      <form
        onSubmit={form.onSubmit(async (values) => {
          await handleSubmit(values)
        })}>
        <TextInput
          required
          label='Nombre(s)'
          placeholder='Nombre(s)'
          {...form.getInputProps("name")}
        />
        <TextInput
          required
          label='Apellidos'
          placeholder='Apellidos'
          mt='sm'
          {...form.getInputProps("lastName")}
        />

        <Group position='center' mt='xl'>
          <Button className='bg-gray-700 text-white hover:bg-gray-600' type='submit'>
            {isCreation ? "Crear Persona" : "Actualizar Persona"}
          </Button>
        </Group>
      </form>
    </>
  )
}

export default SupplierPersonForm
